<div class="modal fade" id="dialogProdutoCadastro" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Cadastro de {{servico ? 'Serviço' : 'Produto'}}</h5>
        <button type="button" class="close" (click)="fechar()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <form [formGroup]="entidadeForm" autocomplete="off">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="produto_cad_grupo" class="required">Grupo</label>
              <select [compareWith]="compareFn" [(ngModel)]="grupoAtual" [ngModelOptions]="{standalone: true}"
                (change)="carregarSubGrupo()" id="produto_cad_grupo" class="form-control">
                <option *ngFor="let item of listaGrupo" [value]="item.id">{{item.codigo}} - {{item.nome}}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="produto_cad_subgrupo" class="required">Sub-Grupo</label>
              <select [compareWith]="compareFn" [(ngModel)]="subGrupoAtual" [ngModelOptions]="{standalone: true}"
                (change)="carregarMaterial()" id="produto_cad_subgrupo" class="form-control">
                <option *ngFor="let item of listaSubGrupo" [value]="item.id">{{item.codigo}} - {{item.nome}}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="produto_cad_material" class="required">Material</label>
              <select [compareWith]="compareFn" formControlName="material" id="produto_cad_material"
                class="form-control">
                <option *ngFor="let item of listaMaterial" [value]="item">{{item.codigo}} - {{item.nome}}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-9">
              <label for="produto_cad_nome" class="required">Nome</label>
              <input id="produto_cad_nome" formControlName="nome" type="text" class="form-control font-weight-bold">
            </div>
            <div class="form-group col-3">
              <label for="produto_cad_unidade" class="required">Und.</label>
              <p-autoComplete *ngIf="unidadeAutoComplete" id="produto_cad_unidade" [(ngModel)]="unidade"
                [forceSelection]="true" [autoHighlight]="true" [ngModelOptions]="{standalone: true}"
                [field]="unidadeAutoComplete.conversor" [suggestions]="unidadeAutoComplete.lista"
                (completeMethod)="unidadeAutoComplete.filtrar($event)" inputStyleClass="form-control form-control-sm"
                minLength="2" [style]="{ width: '100%' }">
                <ng-template let-unidade pTemplate="item">
                  {{unidade.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12 mb-0">
              <label for="produto_cad_descricao" class="required">Descrição</label>
              <textarea id="produto_cad_descricao" formControlName="descricao" type="text"
                class="form-control"> </textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="row" style="width: 100%;">
          <div class="col-4 pl-0">
            <button (click)="submitForm()" type="button" class="btn btn-sm btn-primary"
              [disabled]="!entidadeForm.valid">
              <i class="fa fa-check"></i> Salvar
            </button>
          </div>
          <div class="col-2 offset-6 text-right">
            <button type="button" class="btn btn-sm btn-link" (click)="fechar()">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>